<template>
  <div class="app-change-personal-data">
    <slot name="beforePersonalData">Persönliche Daten</slot>
    <b-form
      :id="'form' + _uid"
      :novalidate="true"
      form-personal-data-input>
      <b-row class="salution">
        <b-col md="" sm="12" class="label">
          <slot name="labelSalutation"> Anrede</slot>
        </b-col>
        <b-col md="" sm="12" class="value">{{ newCustomer.salutation }}</b-col>
      </b-row>
      <b-row class="lastName">
        <b-col md="" sm="12" class="label">
          <slot name="labelLastName">Nachname</slot>
        </b-col>
        <b-col md="" sm="12" class="value">{{ newCustomer.lastName }}</b-col>
      </b-row>
      <b-row class="firstName">
        <b-col md="" sm="12" class="label">
          <slot name="labelFirstName">Vorname</slot>
        </b-col>
        <b-col md="" sm="12" class="value">{{ newCustomer.firstName }}</b-col>
      </b-row>
      <b-form-group class="street-group">
        <b-row class="streetNumber">
          <b-col md="" sm="12" class="label">
            <label class="mandatory">
              <slot name="labelStreetNumber">Straße / Hausnr.</slot>
            </label>
          </b-col>
          <b-col md="" sm="12" class="street">
            <b-form-input
              name="street"
              type="text"
              v-model="newCustomer.address.street"
              required
              @input="$v.newCustomer.address.street.$touch"
              :state="isValid('street','address','newCustomer')"
            ></b-form-input>
          </b-col>
          <b-col md="" sm="12" class="houseNumber">
            <b-form-input
              name="houseNumber"
              type="text"
              v-model="newCustomer.address.houseNumber"
              required
              @input="$v.newCustomer.address.houseNumber.$touch"
              :state="isValid('houseNumber','address','newCustomer')"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="zip-group">
        <b-row class="zipCity">
          <b-col md="" sm="12" class="label">
            <label class="mandatory">
              <slot name="labelZipCity">PLZ / Ort</slot>
            </label>
          </b-col>
          <b-col md="" sm="12" class="zip">
            <b-form-input
              name="zip"
              type="text"
              v-model="newCustomer.address.zip"
              required
              @input="$v.newCustomer.address.zip.$touch"
              :state="isValid('zip', 'address','newCustomer')"
            ></b-form-input>
          </b-col>
          <b-col md="" sm="12" class="city">
            <b-form-input
              name="city"
              type="text"
              v-model="newCustomer.address.city"
              required
              @input="$v.newCustomer.address.city.$touch"
              :state="isValid('city', 'address','newCustomer')"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="supplement-group">
        <b-row class="supplement">
          <b-col md="" sm="12" class="label">
            <label>
              <slot name="labelSupplement">Adresszusatz</slot>
            </label>
          </b-col>
          <b-col md="" sm="12">
            <b-form-input
              name="supplement"
              type="text"
              v-model="newCustomer.address.supplement"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-row class="birthDate">
        <b-col md="" sm="12" class="label">
          <slot name="labelBirthDate">Geburtsdatum</slot>
        </b-col>
        <b-col md="" sm="12" class="value">{{ newCustomer.birthDate }}</b-col>
      </b-row>
      <b-form-group class="phone">
        <b-row>
          <b-col md="" sm="12" class="label">
            <slot name="phone">Telefon</slot>
          </b-col>
          <b-col md="" sm="12" class="phone">
            <b-form-input
              name="phone"
              type="text"
              v-model="newCustomer.alternativePhone"
              required
              @input="$v.newCustomer.alternativePhone.$touch"
              :state="isValid('alternativePhone','newCustomer')"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="email-group">
        <b-row>
          <b-col md="" sm="12" class="label">
            <label class="mandatory">
              <slot name="labelEmail">E-Mail Addresse</slot>
            </label>
          </b-col>
          <b-col md="" sm="12">
            <b-form-input
              name="email"
              type="email"
              required
              @input="$v.newCustomer.email.$touch"
              :state="isValid('email', 'newCustomer')"
              v-model="newCustomer.email"
              aria-describedby="email-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="email-live-feedback">
              <slot v-if="$v.newCustomer.email.email === false" name="emailLiveFeedback">
                keine richtige E-Mail-Adresse
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="email-repeat-group">
        <b-row class="email">
          <b-col md="" sm="12" class="label">
            <label class="mandatory">
              <slot name="emailRepeatLabel">E-Mail-Adresse wiederholen</slot>
            </label>
          </b-col>
          <b-col md="" sm="12">
            <b-form-input
              name="email-repeat"
              type="email"
              required
              @input="$v.emailRepeat.$touch"
              :state="isValid('emailRepeat')"
              v-model="emailRepeat"
              aria-describedby="email-repeat-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="email-repeat-live-feedback">
              <slot v-if="$v.emailRepeat.sameAsEmail === false" name="emailRepeatLiveFeedback">
                E-Mail-Adresse nicht identisch
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
    </b-form>
    <EvnSelect :evn-selected.sync="newEvn.evn">
      <template v-for="slot in possibleChildSlotsFor('Select')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </EvnSelect>
    <Stepper
      @next="save()"
      :loading-next="loading"
      @prev="backView()"
      :disabled-next="$v.$invalid || loading"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { BForm, BFormInput, BRow, BCol, BFormGroup, BFormInvalidFeedback } from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import { email, required, sameAs } from 'vuelidate/lib/validators'
import { validZipCode, validCityString } from '@/validators/address'
import isValid from '@/mixins/isValid'
import Stepper from '@/components/generic/Stepper.vue'
import slotProxy from '@/mixins/slotProxy'
import cloneDeep from 'lodash.clonedeep'
import EvnSelect from '@/components/process/generic/ItemisedBills/Select.vue'

export const stepName = 'changePersonalData'
export default {
  name: 'ChangePersonalData',
  data () {
    return {
      newCustomer: cloneDeep(this.currentCustomer),
      newEvn: cloneDeep(this.currentEvnConfiguration),
      emailRepeat: this.currentCustomer.email,
      loading: false
    }
  },
  components: {
    BFormInput,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInvalidFeedback,
    Stepper,
    EvnSelect
  },
  methods: {
    ...mapMutations('personalData', [
      'changeView'
    ]),
    ...mapActions('personalData', [
      'changePersonalData'
    ]),
    async save () {
      this.loading = true
      const success = await this.changePersonalData({
        newCustomer: this.newCustomer,
        newEvn: this.newEvn.evn
      })
      this.$emit('refresh')
      /*
       * change view is not in the store,
       * because the emit must be executed before the component is changed
       */
      if (success) {
        this.changeView('personalDataChangeSuccess')
      } else {
        this.changeView('viewPersonalData')
      }
      this.loading = false
    },
    backView () {
      this.changeView('viewPersonalData')
    },
    setEmailRepeat (data) {
      this.emailRepeat = data.email
    }
  },
  mixins: [
    validationMixin,
    isValid,
    slotProxy()
  ],
  validations () {
    return {
      newCustomer: {
        alternativePhone: {},
        address: {
          street: {
            required
          },
          houseNumber: {
            required
          },
          zip: {
            validZipCode,
            required
          },
          city: {
            validCityString,
            required
          }
        },
        email: {
          required,
          email
        }
      },
      emailRepeat: {
        required,
        email,
        sameAsEmail: sameAs(function () {
          return this.newCustomer.email
        })
      }
    }
  },
  props: {
    currentCustomer: {
      type: Object
    },
    currentEvnConfiguration: {
      type: Object
    }
  }
}
</script>
